define.alias("shared/components/shared/social/linkedin-profile-info-modal", "calendar/components/shared/social/linkedin-profile-info-modal");